<template>
  <LoadingDados v-if="loading.loading" :mgs="loading.loadingMgs"/>
  <ModalValidadorDocumentos v-show="vermodal" @fecharModal="fecharModal"/>
  <section>
    <Dialog v-model:visible="openModal" modal header=" " :style="{ width: '50vw' }"
            :breakpoints="{ '960px': '75vw', '641px': '100vw' }">
    <span class="base-dialogo">
    <h3>{{ mensagemModal.titulo || '' }}</h3>
    <p>
      {{ mensagemModal.paragrafo || '' }} <br/>
      <small>
        <strong>{{ mensagemModal.paragrafoSmall || '' }}</strong>
      </small>
    </p>
      <span class="botao btn-continue" @click="cliqueContinue">
        <strong> {{ mensagemModal.botao || '' }} </strong>
      </span>
    </span>
    </Dialog>
    <form method="post" enctype="multipart/form-data">
      <div class="box" v-if="etapa == 1">
        <section class="box-section">
      <span class="box-info">
        <span class="box-titulo">ENVIE SEU DOCUMENTO COM FOTO</span>
        <p class="box-descricao desc-selfie">
          <i>Ao enviar uma imagem da sua <strong>CNH</strong> ou <strong>RG</strong> (ABERTO), extrairemos os detalhes para você</i>.
        </p>
        <p class="box-descricao desc-selfie">
          <i>Em caso de <strong>Pessoa Jurídica</strong>, por favor enviar o documento do representante legal.</i>
        </p>
      </span>
          <div class="box-inputs">
        <span class="box-base-input">
          <label for="document" class="box-label"><span>SELECIONE SEU DOCUMENTO</span></label>
          <span class="box-btn"> > </span>
        </span>
            <input type="file" ref="inputDocument" name="document" id="document" accept=".jpg,.jpeg,.png,.pdf"
                   @change="verFile($event, 1)">
          </div>
        </section>
        <section class="box-footer">
      <span class="box-footer-base">
        <img src="@/assets/img/bases/Vector.png" alt="" class="img-vetor">
        <span class="box-footer-duvida"><a :href="link_ajuda" target="_blank">Dúvida? Posso ajudar</a></span>
      </span>
        </section>
      </div>

      <div class="box" v-if="etapa == 4">
        <section class="box-section">
      <span class="box-info">
        <span class="box-titulo">ENVIE {{ textFrenteVerso.titulo }}</span>
        <p class="box-descricao desc-selfie">
          <i>Envie {{ textFrenteVerso.titulo }} do documento oficial, extrairemos os detalhes para você</i>.
        </p>
        <p class="box-descricao desc-selfie">
          <i>Em caso de <strong>Pessoa Jurídica</strong>, por favor enviar o documento do representante legal.</i>
        </p>
      </span>
          <div class="box-inputs">
        <span class="box-base-input">
          <label for="document" class="box-label"><span>SELECIONE {{ textFrenteVerso.titulo }}</span></label>
          <span class="box-btn"> > </span>
        </span>
            <input type="file" ref="inputDocument" name="document" id="document" accept=".jpg,.jpeg,.png,.pdf"
                   @change="verFile($event, 2)">
          </div>
        </section>
        <section class="box-footer">
      <span class="box-footer-base">
        <img src="@/assets/img/bases/Vector.png" alt="" class="img-vetor">
        <span class="box-footer-duvida"><a :href="link_ajuda" target="_blank">Dúvida? Posso ajudar</a></span>
      </span>
        </section>
      </div>

      <div class="box" v-if="etapa == 2">
        <section class="box-section" id="box-section" v-show="!registrarSelfie">
        <span class="box-info">
        <span class="box-titulo">CONFIRMAÇÃO POR SELFIE</span>
        <p class="box-descricao desc-selfie">
         Escolha uma das opções abaixo:
          <i>
            <br/><strong>Carregar selfie</strong> - selecione uma foto do seu dispositivo ou, se estiver usando um dispositivo móvel, tire a foto na hora."
          </i>
        </p>
        </span>
          <div class="box-inputs">
        <span class="box-base-input">
          <label for="selfie" class="box-label"><span>CARREGAR SELFIE</span></label>
          <span class="box-btn"> > </span>
        </span>
            <input type="file" ref="inpuitSelfie" name="selfie" id="selfie" accept=".jpg,.jpeg,.png,.pdf"
                   @change="verFile($event, 2)">
          </div>
        </section>
        <div v-show="registrarSelfie" id="wrapper">
          <div id="video-wrapper"></div>
        </div>
        <section class="box-footer">
      <span class="box-footer-base">
        <img src="@/assets/img/bases/Vector.png" alt="" class="img-vetor">
        <span class="box-footer-duvida"><a :href="link_ajuda" target="_blank">Dúvida? Posso ajudar</a></span>
      </span>
        </section>
      </div>
    </form>
  </section>
</template>
<script>
import validadorDocumentos from "../mixins/validadorDocumentos.js"

export default {
  mixins: [validadorDocumentos]
}
</script>